import React, { ReactElement, useEffect } from 'react';
import { useConfig } from '../hooks/useConfig';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  interface Window { wootric: any; }
}

export interface WootricProps {
  //Required to uniquely identify a user. Email is recommended but this can be any unique identifier.
  userIdentifier: string;
  //days before wootric is first shown can be adjusted in wootric and uses createdAt to decide when 
  userCreatedAt: Date;
  //custom attributes
  isModetator: boolean;
  userName: string;
  // Additional properties for user identification
  isRegistered: boolean;
  planType?: string;
}

export default function Wootric(props: WootricProps): ReactElement {
  const config = useConfig();
  
  //email: Required to uniquely identify a user. Email is recommended but this can be any unique identifier.
  //createdAt: The current logged in user's sign-up date as a Unix timestamp.
  useEffect(() => {
    if (!config.WOOTRIC_ACCOUNT_TOKEN) {
      return;
    }

    const setupScript = document.createElement('script');
    setupScript.type = 'text/javascript';
    setupScript.id = 'wootric-settings';
    setupScript.async = true;
    setupScript.innerHTML = `
      wootric_no_surveyed_cookie = ${config.WOOTRIC_DEBUG_MODE_ENABLED || 'false'};
      wootric_survey_immediately = ${config.WOOTRIC_DEBUG_MODE_ENABLED || 'false'};
      window.wootricSettings = {
        email: '${props.planType || "Guest"}_${props.userIdentifier}',
        created_at: ${Math.floor(props.userCreatedAt.getTime()/1000)},
        account_token: '${config.WOOTRIC_ACCOUNT_TOKEN}',
        modal_theme: 'light',
        modal_footprint: 'compact',
        properties:{
          user_name:'${props.userName}',
          user_role:'${props.isModetator ? "Moderator" : "Participant"}',
          user_type:'${props.isRegistered ? "Registered" : "Guest"}',
          plan_type:'${props.planType || "None"}',
          ${props.isRegistered ? `external_id:'${props.userIdentifier}'` : ''}
        }
      };
    `;
    if (document.getElementById('wootric-settings') == null) {
      document.body.appendChild(setupScript);
    }

    // Beacon
    const beacon = document.createElement('script');
    beacon.type = 'text/javascript';
    beacon.id = 'wootric-beacon';
    beacon.async = true;

    beacon.src = 'https://cdn.wootric.com/wootric-sdk.js';
    beacon.onload = function () {
      window.wootric('run');
    };
    if (document.getElementById('wootric-beacon') == null) {
      document.body.appendChild(beacon)
    }
  }, []);

  return (
    <div />
  );
}